import { render, staticRenderFns } from "./chateau-latour.vue?vue&type=template&id=0c5db060&scoped=true"
import script from "./chateau-latour.vue?vue&type=script&lang=js"
export * from "./chateau-latour.vue?vue&type=script&lang=js"
import style0 from "./chateau-latour.vue?vue&type=style&index=0&id=0c5db060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5db060",
  null
  
)

export default component.exports